<template>
  <div class="auth-layout">
    <main class="auth-main">
      <router-view />
    </main>
  </div>
</template>

<style scoped>
.auth-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: var(--bg-color, #fafafa);
}

.auth-main {
  width: 100%;
  max-width: 420px;
  padding: 2rem;
  background: white;
  border-radius: 16px;
  box-shadow: var(--shadow-md, 0 4px 16px rgba(0,0,0,0.1));
}
</style>
